import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TooltipPosition } from '@angular/material/tooltip';
import { ToastrService } from 'ngx-toastr';
import { HttpService } from 'src/app/services/http/http.service';

@Component({
  selector: 'app-weekly-top',
  templateUrl: './weekly-top.component.html',
  styleUrls: ['./weekly-top.component.scss']
})
export class WeeklyTopComponent implements OnInit {

  constructor(
    private httpSv: HttpService,
    private changeDetection: ChangeDetectorRef,
    private toster: ToastrService
  ) { }
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  positionOptions: TooltipPosition[] = ['below', 'above', 'left', 'right'];
  position = new FormControl(this.positionOptions[0]);
  ngOnInit(): void {
    this.allTableData.paginator = this.paginator;
    this.getAllRestoList()
    this.getTenRestoList()
  }
  ngAfterViewInit() {
    this.allTableData.paginator = this.paginator;
  }
  // Top ten list
  topTenTableDataDisplayedColumns = ['id', 'name', 'action',]
  topTenData: any[] = []
  topTenTableData: MatTableDataSource<[]> = new MatTableDataSource()

  //All resto list
  allRestoData: any[] = []
  noOfResoData: any
  allTableDisplayedColumns = ['id', 'name', 'action',]
  allTableData: MatTableDataSource<[]> = new MatTableDataSource();
  searchText: any;
  getAllRestoList() {
    this.httpSv.getAllLevelRestoList().subscribe(res => {
      if (res['status'] == "TRUE") {
        this.allRestoData = res['result'].data
        this.noOfResoData = this.allRestoData.length
        this.allTableData = new MatTableDataSource(this.allRestoData)
        this.allTableData.paginator = this.paginator;
      }
    })

  }
  getTenRestoList() {
    this.httpSv.getAllWeeklyRestoList().subscribe(res => {
      if (res['status'] == "TRUE") {
        this.topTenData = res['result'].data
        this.topTenTableData = new MatTableDataSource(this.topTenData)
      }
    })
  }
  dropFromList(ele, index) {
    this.topTenData.splice(index, 1)
    this.topTenTableData = new MatTableDataSource(this.topTenData)
    this.updateTopTen()
  }
  addToList(ele, index) {
    let key = Object.keys(ele)
    key = key.filter(ele => ele.includes('restaurant_id') || ele.includes('csv_restaurantId') || ele.includes('claim_restaurantId'))

    // In top ten already exist or not check
    let exist = false
    this.topTenData.forEach(element => {
      try {
        if (element[key[0]] == ele[key[0]]) {
          this.toster.error(`${ele.restaurant_name} is already in weekly list`, '', {
            timeOut: 3000
          })
          exist = true
          return
        }
      }
      catch (err) {
        console.error(err)
      }
    })
    if (exist) {
      return
    }
    // Number of restaurant check
    if (this.topTenData.length == 10) {
      this.toster.error('Already 10 are selected. Before adding remove anyone', '', {
        timeOut: 3000
      })
      return
    }
    //Adding to top ten list
    ele['categories'].push({
      "category_id": "42",
      "category_name": "WEEK10"
    })
    this.topTenData.push(ele)
    this.topTenTableData = new MatTableDataSource(this.topTenData)
    this.updateTopTen()
  }
  filter() {
    if (this.searchText == "") {
      this.allTableData = new MatTableDataSource(this.allRestoData);
      this.allTableData.paginator = this.paginator
    } else {
      let temp = this.allRestoData.filter((ele: any) => {
        return ele.restaurant_name
          .toLocaleLowerCase()
          .match(this.searchText.toLocaleLowerCase());
      });
      this.allTableData = new MatTableDataSource(temp);
      this.allTableData.paginator = this.paginator
    }
    this.changeDetection.detectChanges()

  }
  updateTopTen() {
    let data = {
      weekely_top10_category: "42",

    }
    let temp = JSON.parse(JSON.stringify(this.topTenData))
    temp.forEach(ele => {
      delete ele.restaurant_name
      let catIds = []
      ele.categories.forEach(ele => {
        catIds.push(ele.category_id)
      })
      delete ele.categories
      ele['category'] = catIds.toString()
    })
    data['restaurants'] = temp
    this.httpSv.updateWeeklyList(data).subscribe(res => {
      if(res['status']=="TRUE"){
        this.getTenRestoList()
      }
      else{
        this.toster.error(res['message'],'',{
          timeOut:3000
        })
      }
    }, err => {
      if(err.status == 500){
        this.toster.error('Oops!! Something went wrong','',{
          timeOut:3000
        })
      }
      else{
        this.toster.error(err.error.message, '', {
          timeOut:3000
        })
      }
    })
  }











}
